import { f as n } from "./fails.js";
var t = !n(function () {
  var n = function () {}.bind();
  return "function" != typeof n || n.hasOwnProperty("prototype");
});
export { t as f };